module.exports = __webpack_public_path__ + "img/G2.4719b7b5.png";